import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Contact from '../Components/Contact/Contact'
import HomePage from '../Components/HomePage/HomePage'
import HomePageGoogle from '../Components/HomePageGoogle/HomePageGoogle'
import HomePageGoogleAirDuct from '../Components/HomePageGoogleAirDuct/HomePageGoogleAirDuct'
import HomePageGoogleDryer from '../Components/HomePageGoogleDryer/HomePageGoogleDryer'
import SiteMap from '../Tools/SiteMap/SiteMap'
import NotFound from '../Tools/NotFound/NotFound'
import Thanks from '../Tools/Thanks/Thanks'
import BookAnAppointment from '../Components/BookAnAppointment/BookAnAppointment'
import BookAnAppointmentEasify from '../Components/BookAnAppointment/BookAnAppointmentEasify'
import ThanksContact from '../Tools/ThanksContact/ThanksContact'
import PrivacyPolicy from '../Tools/PrivacyPolicy/PrivacyPolicy'
import TermsAndConditions from '../Tools/TermsAndConditions/TermsAndConditions'
import About from '../Components/About/About'
import ServicesAll from '../Components/ServicesAll/ServicesAll'
import ServicesPage from '../Components/ServicesPage/ServicesPage'
import HomePageCity from '../Components/HomePageCity/HomePageCity'


export default function Main({ locationsMain, CitiePhone, CitiesData, navigateTo, WebSitePages }) {

    return (
        // <div>
        <Routes>
            <Route path="/" element={<HomePage CitiePhone={CitiePhone} navigateTo={navigateTo}   />} />
            {/* SEO landing pages (full nav + footer) */}
            <Route path="/chimney/*" element={<HomePageGoogle locationsMain={locationsMain} CitiePhone={CitiePhone} CitiesData={CitiesData} navigateTo={navigateTo} />} />
            <Route path="/airduct/*" element={<HomePageGoogleAirDuct locationsMain={locationsMain} CitiePhone={CitiePhone} CitiesData={CitiesData} navigateTo={navigateTo} />} />
            <Route path="/dryer/*" element={<HomePageGoogleDryer locationsMain={locationsMain} CitiePhone={CitiePhone} CitiesData={CitiesData} navigateTo={navigateTo} />} />
            {/* Ads landing pages (limited nav). Campaigns route to /local/{service}/* by ad type. */}
            <Route path="/local" element={<HomePageGoogle locationsMain={locationsMain} CitiePhone={CitiePhone} CitiesData={CitiesData} navigateTo={navigateTo}   />} />
            <Route path="/local/chimney/*" element={<HomePageGoogle locationsMain={locationsMain} CitiePhone={CitiePhone} CitiesData={CitiesData} navigateTo={navigateTo} />} />
            <Route path="/local/airduct/*" element={<HomePageGoogleAirDuct locationsMain={locationsMain} CitiePhone={CitiePhone} CitiesData={CitiesData} navigateTo={navigateTo} />} />
            <Route path="/local/dryer/*" element={<HomePageGoogleDryer locationsMain={locationsMain} CitiePhone={CitiePhone} CitiesData={CitiesData} navigateTo={navigateTo} />} />
            {/* Services */}
            <Route path="/services" element={<ServicesAll CitiePhone={CitiePhone} />} />
            <Route path="/service/:service" element={<ServicesPage CitiePhone={CitiePhone} CitiesData={CitiesData} locationsMain={locationsMain} navigateTo={navigateTo} />} />
            <Route path="/service/:service/:city" element={<ServicesPage CitiePhone={CitiePhone} CitiesData={CitiesData} locationsMain={locationsMain} navigateTo={navigateTo} />} />
            {/* City pages */}
            <Route path="/city/:city" element={<HomePageCity CitiePhone={CitiePhone} CitiesData={CitiesData} locationsMain={locationsMain} navigateTo={navigateTo} />} />
            {/*  */}
            <Route path="/contact" element={<Contact CitiePhone={CitiePhone} />} />
            <Route path="/about" element={<About CitiePhone={CitiePhone} />} />
            <Route path="/book/*" element={<BookAnAppointment locationsMain={locationsMain} CitiesData={CitiesData} CitiePhone={CitiePhone} />} />
            <Route path="/booke" element={<BookAnAppointmentEasify locationsMain={locationsMain} CitiesData={CitiesData} CitiePhone={CitiePhone} />} />
            <Route path="/thanks" element={<Thanks CitiePhone={CitiePhone} navigateTo={navigateTo} />} />
            <Route path="/thankscontact" element={<ThanksContact CitiePhone={CitiePhone} navigateTo={navigateTo} />} />

            {/* Privacy Policy */}
            <Route path="/privacy-policy" element={<PrivacyPolicy/>} />
            <Route path="/terms-and-conditions" element={<TermsAndConditions/>} />

            {/* SiteMap */}
            {["/sitemaps", "/sitemap", "/widgets"].map((path, index) =>
                <Route path={path} key={index} element={<SiteMap CitiePhone={CitiePhone}   WebSitePages={WebSitePages} />} />
            )}
            <Route path="/sitemap/:id" element={<SiteMap CitiePhone={CitiePhone}   WebSitePages={WebSitePages} />} />
            {/* 404 */}
            <Route path="*" element={<NotFound CitiePhone={CitiePhone} />} />
        </Routes>
        // </div>
    )
}
